import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'normalize.css';
import './index.scss';
import {ServerDataProvider} from "./context/ServerDataContext";
import {ThemeProvider} from "./context/ThemeContext";
import {initOfflineMode} from "./offline";
import {isOfflineMode} from "./utils/util-functions";

const render = () => {
    const container = document.getElementById('root');

    if (container !== undefined) {
        const root = createRoot(container as HTMLElement);
        root.render(
            <React.StrictMode>
                <ServerDataProvider>
                    <ThemeProvider>
                        <App/>
                    </ThemeProvider>
                </ServerDataProvider>
            </React.StrictMode>,
        );
    }
}

if (isOfflineMode()) {
    initOfflineMode(render);
} else {
    render();
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
